 /**
 * Shooping Cart
 */
/// subscribe box
$('.cart--tabs #subscribeBox').on("click", function () {
    // e.preventDefault();

    $(this).find('.cart__checkbox').toggleClass('checked');
    $('.cart--tabs .cta').toggleClass('disabled');

    //- Reset S&S click on disable alert
    if($(this).find('.cart__checkbox').hasClass('alert')) {
        $(".subscribe-box__alert").removeClass('show');
        $(this).find('.cart__checkbox').removeClass('alert');
    }
})

//// activate subscribe prices    
let cartModeCTA = $('.cart--tabs .cart__mode-cta'),
    subscribeMode = $('.cart--tabs .purchaseMode'),
    subscribeModeDoubleSS = $('.cart--tabs #subscribeModeDoubleSS'),
    disclaimerBox = $('.cart--tabs #disclaimerBox');

$(cartModeCTA).on('click', function () {
    let thisBtn = $(this);
        
    cartModeCTA.removeClass('active');
    thisBtn.addClass('active');
    
    if (thisBtn.hasClass('subscribe')) {
        $('.cart--tabs').attr('data-subscribe', 'subscribe');
        $('#subscribeWrap').removeClass('hide').addClass('show');

        if(thisBtn.attr('data-checkbox') === 'true') {
            $('.cart .cta').addClass('disabled');
        }

    } else {
        resetSubscribe();
    }
    $('.cart__product.active').trigger("click");
});

$('#subscribeInput').on('click', function (check) {
    // console.log($(this).is(":checked"));
    
    let checkboxType;

    if ($('.cart--tabs').attr('data-subscribe') === 'unsubscribe') {
        checkboxType = true;

        subscribeOn();

        if(subscribeModeDoubleSS.length) {
            $('.cart .cta').addClass('disabled');
        }
        
    } else {
        checkboxType = false;
        
        subscribeOff();

        if(subscribeModeDoubleSS.length) {
            $('.cart .cta').removeClass('disabled');

            resetSubscribe();
        }
    }

    this.setAttribute('checked', checkboxType);

    $('.cart__product.active').trigger("click");
});

function subscribeOn() {
    $('.cart--tabs').attr('data-subscribe', 'subscribe');
    subscribeMode.attr('data-subscribe', 'subscribe');
    disclaimerBox.addClass('subscribe-box__disclaimer--open');
    $('.cart__shipping--hideOnSS').hide();
}

function subscribeOff() {
    $('.cart--tabs').attr('data-subscribe', 'unsubscribe')
    subscribeMode.attr('data-subscribe', 'unsubscribe');

    // on touch screens
    if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
        disclaimerBox.removeClass('subscribe-box__disclaimer--open');
    }

    $('.cart__shipping--hideOnSS').show();
}

function resetSubscribe() {
    $('.cart--tabs').attr('data-subscribe', 'unsubscribe')
    $('#subscribeWrap').removeClass('show').addClass('hide');

    $('.cart .cta').removeClass('disabled');

    $('#subscribeBox .cart__checkbox').removeClass('checked');

    //- Reset S&S click on disable alert
    if($('#subscribeBox .cart__checkbox').hasClass('alert')) {
        $(".subscribe-box__alert").removeClass('show');
        $(".cart__checkbox").removeClass('alert');
    }
}

// Add alert 
$('.wrapCTA').on('click', function () {
    if($('#cartCTA').hasClass('disabled')){
        $(".subscribe-box__alert").addClass('show');
        $(".cart__checkbox").addClass('alert');
    }
})

/**
 * Replace CTA HTML if data-subscribe-text exists 
 */
function replaceCTAHtml(ctaHTML) {    
    if (ctaHTML) {
        $('#ctaText').html(ctaHTML)
    }
}

////set prices
function setLinks() {
    let thisProduct = $(this);
    let link, ctaHTML,
        timeSensitiveBanner = '', 
        ship;
    const subscribe = $('#choosePrices').attr('data-subscribe');
    const subscribeCheckbox = $('.cart--tabs').attr('data-subscribe');

    if (subscribeCheckbox === 'subscribe') {
        link = 'data-subscribe-link';
        ctaHTML = $('.cart .cta').data('subscribe-text');
    } else {
        link = 'data-link';
        ctaHTML = $('.cart .cta').data('text');

        if ($(body).hasClass('show-timeSensitiveBanner')) {
            timeSensitiveBanner = '-time-sensitive';
            ship = 'data-shipping-time-sensitive';

        } else {
            timeSensitiveBanner = '';
        }
    }

    adjustUtmContent();
    
    let param = $('.cta').attr('data-param');

    // console.log(thisProduct.attr(link));
    // console.log(thisProduct.attr(link).includes('?'));
    // console.log(param);

    replaceCTAHtml(ctaHTML);

    $('.cart .cta').attr('href', thisProduct.attr(link + timeSensitiveBanner) + param);
}

function normalActiveProduct() {
    let thisProduct = $(this);
    let amount, link, ship;
    const units = thisProduct.attr('data-units');
    const subscribe = $('#choosePrices').attr('data-subscribe');
    const subscribeCheckbox = $('.cart--tabs').attr('data-subscribe');
    const badge = 'data-badge';
    const secondBadge = 'data-second-badge';

    if (subscribeCheckbox === 'subscribe') {
        amount = 'data-subscribe-price';
        // link = 'data-subscribe-link';
        ship = 'data-subscribe-shipping';

        $('.cart__details').addClass('cart__details--subscribe');
    } else {
        amount = 'data-price';
        // link = 'data-link';
        ship = 'data-shipping';

        $('.cart__details').removeClass('cart__details--subscribe');
    }

    if ($(body).hasClass('show-timeSensitiveBanner')) {
        timeSensitiveBanner = '-timeSensitiveBanner';
        ship = 'data-shipping-time-sensitive';

    } else {
        timeSensitiveBanner = '';
    }
    
    $('#defaultBadgeText').html(thisProduct.attr(badge));
    $('#secondBadgeText').html(thisProduct.attr(secondBadge));   

    $('.cart__product').removeClass('active');
    thisProduct.addClass('active');

    $("#orderNow").removeClass(function (index, className) {
        return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
    }).addClass('cart--unit' + units);

    $('.cart__unit-value').html('$' + parseFloat(
        (thisProduct.attr(amount)) / (thisProduct.attr('data-units'))
    ).toFixed(2));

    $('.cart__current-value').html('$' + thisProduct.attr(amount));
    $('.cart__retail-value').html('$' + thisProduct.attr('data-retail'));
    $('.cart__shipping-value').html(thisProduct.attr(ship));
    $('.cart__instant-savings-value').html('$' + (Number(thisProduct.attr('data-retail')) - Number(thisProduct.attr(amount))).toFixed(2))
};

$('.cart--tabs .cart__product').on('click', normalActiveProduct);
$('.cart--tabs .cart__product').on('click', setLinks);
$('.cart--tabs .cart__product.active').trigger("click");


const clickableReviews = $('#clickableReviews');
if ($(clickableReviews).length) {
    $(clickableReviews).on('click', function(){
        $('html, body').animate({
            scrollTop: $('#testimonialsBanner').offset().top
        }, 1000);
    });
}

if (scrollOnSSCheckbox) {
    $('#subscribeModeDoubleSS').on('mouseup', function(e){
        if (e.currentTarget.attributes['data-subscribe'].value == 'unsubscribe') {
            $('html, body').animate({
                scrollTop: $('#subscribeModeDoubleSS').offset().top - 40
            }, 1000);
        }
    });
}

if ($('#cartHero').length) {
    $('.cart__hero-cta').on('click', function(e){
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $('.cart__title').offset().top - 40
        }, 1000);
    });
}
        